import { Collapse } from 'antd';
import styled from 'styled-components';

export const PanelContainer = styled(Collapse.Panel)`
  display: flex;
  justify-content: space-around;
  align-content: center;
  flex-direction: column;
  align-items: stretch;
  padding: 6px 6px 3px;
`;
